import React from 'react';
import { Tooltip } from '@wix/design-system';
import { useTranslation } from '../../../useTranslation';
import { getTooltipMessage } from '../tooltips';
import { GroupPreview } from '../../controls/GroupPreview/GroupPreview';
import type {
  GlobalDesignStyleGroup,
  StylesDerivedNativeActionNames,
} from '../../types';

export type LobbyItemLayoutProps = {
  actionName: StylesDerivedNativeActionNames;
  group: GlobalDesignStyleGroup;
  onSelect: () => void;
  children: React.ReactNode;
};

export const LobbyItemLayout: React.FC<LobbyItemLayoutProps> = ({
  actionName,
  group,
  onSelect,
  children,
}) => {
  const [t] = useTranslation();

  return (
    <Tooltip enterDelay={500} content={getTooltipMessage(t, actionName, group)}>
      <GroupPreview onClick={onSelect} dataHook={`${actionName}-group-preview`}>
        {children}
      </GroupPreview>
    </Tooltip>
  );
};
